import { render, staticRenderFns } from "./Nominated.vue?vue&type=template&id=4afdfc1d&scoped=true"
import script from "./Nominated.vue?vue&type=script&lang=js"
export * from "./Nominated.vue?vue&type=script&lang=js"
import style0 from "./Nominated.vue?vue&type=style&index=0&id=4afdfc1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afdfc1d",
  null
  
)

export default component.exports